import { useEffect } from 'react'
import { Field } from 'react-final-form'

import { SelectValue } from 'common/components/BaseSelect'
import SingleSelect from 'common/components/singleSelect'
import { useAppDispatch } from 'common/hooks/redux'
import { updateTemplateSplitConfiguration } from 'features/unifiedFlow/store/unifiedFlowSlice'

import { TemplateInfoWithInternalId } from '../../addedTemplates/AddedComponentList'
import { getExperimentPrefixedName } from '../../helpers'

import CalculatorCard from './components/CalculatorCard'

const splitNumberOptions = [
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8', value: '8' },
  { label: '9', value: '9' },
  { label: '10', value: '10' },
]

type Props = {
  template: TemplateInfoWithInternalId
}

const VariantDropdown = ({ template }: Props) => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(
      updateTemplateSplitConfiguration({
        internalId: template.internalId,
        splitConfiguration: {
          type: 'variant_dropdown',
        },
      })
    )
  }, [dispatch, template.internalId])

  return (
    <CalculatorCard className="items-center justify-between">
      <div className="text-sm font-medium text-coolGray-800">
        Select the number of variants you want to test:
      </div>
      <Field<SelectValue>
        name={getExperimentPrefixedName(template, 'splitNumber')}
      >
        {({ input }) => (
          <SingleSelect
            className="w-32"
            data-cy="split-number-select"
            id={input.name}
            name={input.name}
            value={input.value.value || '10'}
            onChange={input.onChange}
            onBlur={input.onBlur}
            options={splitNumberOptions}
            menuPortalTarget={document.body}
            tabIndex={-1} // TODO: Default tabIndex={0} is causing an issue with the slidePanel when navigating with TAB key
          />
        )}
      </Field>
    </CalculatorCard>
  )
}

export default VariantDropdown
